import { Box } from "@mui/material";
import { useState } from "react";
import { DisclosureHost } from "../hooks/use-disclosure";
import CustomTextArea from "./CustomTextArea";
import Flex from "./Flex";
import SideSheetDrawer from "./SidesheetDrawer";
import Text from "./Text";

type AllFilePreviewProps = {
  fileType: "pdf" | "img" | "text" | "video" | "other";
  file?: any;
  disclosureHost: DisclosureHost;
  title?: string;
  w?: string;
};

/**
 * @description To PreView ``pdf``,``img``, ``text``, ``video``, Or ``other`` files
 *
 * @param {fileType} fileType
 *
 * @author Rajkumar Rathod
 */
const AllFilePreview: React.FC<AllFilePreviewProps> = ({
  fileType,
  file,
  disclosureHost,
  title,
  w = "100vw",
}) => {
  const [text, setText] = useState("");

  const fallBack = () => (
    <Flex
      width={"100%"}
      height={"60svh"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Text>No File Available To Preview</Text>
    </Flex>
  );

  const fetchFileContent = async (file: string) => {
    try {
      const response = await fetch(file);
      const data = await response.text();
      setText(data);
    } catch (error) {
      console.error("Error fetching file content:", error);
    }
  };

  const renderPreview = () => {
    if (fileType === "img") {
      return (
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          height={"50vh"}
          width={"100%"}
        >
          <img
            src={file}
            alt="Preview"
            style={{ maxWidth: "100%", height: "100%" }}
          />
        </Flex>
      );
    } else if (fileType === "pdf") {
      return (
        <iframe
          src={file}
          style={{ height: "calc(100svh - 120px)", width: "100%" }}
        />
      );
    } else if (fileType === "text") {
      fetchFileContent(file);

      return <CustomTextArea minRows={12} disabled value={text} />;
    } else if (fileType === "video") {
      return (
        <video autoPlay controls width={"100%"} height={"100%"}>
          <source src={file} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    } else {
      const link = document.createElement("a");
      link.href = file;
      document.body.appendChild(link);
      link?.click();
      document.body.removeChild(link);
      disclosureHost.close();
    }
  };

  return (
    <SideSheetDrawer
      w={w}
      open={disclosureHost.opened}
      title={title ?? "Preview"}
      onClose={disclosureHost.close}
    >
      <Box>{file ? renderPreview() : fallBack()}</Box>
    </SideSheetDrawer>
  );
};

export default AllFilePreview;
